// ** React Imports
import { Navigate } from 'react-router-dom';
import { Suspense } from 'react';

// ** Context Imports
import { useSelector } from 'react-redux';

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const {
    auth: { userData: user }
  } = useSelector((state) => state);

  if (route) {
    let restrictedRoute = false;
    let permission = '';
    let allow = false;
    let accessControl = false;

    if (route.meta) {
      restrictedRoute = route.meta.restricted;
      permission = route.meta.permission;
      allow = user?.permissions?.includes(permission);
      if (permission === 'DASHBOARD' && !allow) {
        accessControl = true;
        restrictedRoute = true;
      } else if (!allow) {
        restrictedRoute = true;
      }
    }
    if (!user) {
      return <Navigate to="/login" />;
    }

    if (user && restrictedRoute && allow) {
      return <Navigate to="/misc/not-authorized" />;
    }
    if (user && restrictedRoute && accessControl && !allow) {
      return <Navigate to="/access-control" />;
    }
  }

  return <Suspense fallback={null}>{children}</Suspense>;
};

export default PrivateRoute;
